import {environment} from "./environments/environment";

export const httpRequestOptions = {
   withCredentials : !environment.disableCsrf
}
